// export const BASE_URL = "http://127.0.0.1:8000"


// export const BASE_URL = "http://192.168.0.2:8001"
//  export const BASE_URL = "https://admin.vinimark.stageoptimal.co.za"
export const BASE_URL = "https://admin.vinimark.co.za"

export const IMAGE_URL = BASE_URL + "/public"
// export const IMAGE_URL = BASE_URL ;

